import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { CircleIcon } from "lucide-react";

//
// RadioGroup Root
//
export function RadioGroup(
  props: React.ComponentProps<typeof RadioGroupPrimitive.Root> & {
    style?: React.CSSProperties;
  }
) {
  const { style, ...rest } = props;

  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      style={{
        display: "grid",
        gap: "12px",
        ...style,
      }}
      {...rest}
    />
  );
}

//
// RadioGroup Item
//
export function RadioGroupItem(
  props: React.ComponentProps<typeof RadioGroupPrimitive.Item> & {
    style?: React.CSSProperties;
    color?:any
  }
) {
  const { style,color, ...rest } = props;

  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      style={{
        width: "16px",
        height: "16px",
        minWidth: "16px",
        minHeight: "16px",

        backgroundColor: "white",
        borderRadius: "9999px",
        border: "1px solid #d1d5db",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        cursor: "pointer",
        transition: "all 150ms",

        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",

        outline: "none",

        ...style,
      }}
      {...rest}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        style={{
          width: "100%",
          height: "100%",

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          position: "relative",
        }}
      >
        <CircleIcon
          style={{
            width: "8px",
            height: "8px",

            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",

            color:color?color: "#2563eb",
            fill:color?color: "#2563eb",
          }}
        />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}
